// extracted by mini-css-extract-plugin
export default {"checkout":"Checkout_checkout__FXs6v","grid__span__2":"Checkout_grid__span__2__k3pDT"};